import React from 'react';
import { Container, Typography, Card, CardMedia, CardContent, Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import image from '../assets/image.jpg';

const Home: React.FC = () => {

  return (
    <>
      <Container sx={{ mt: 4 }}>
        <Card sx={{ mb: 4 }}>
          <CardMedia
            component="img"
            height="400"
            image={image}
            alt="Simulados ANAC - Ferramenta de Valor Recorrente para Aviação"
          />
          <CardContent>
            <Typography variant="h4" gutterBottom>
              Bem-vindo ao Simulados ANAC - Sua FVR de Preparação
            </Typography>
            <Typography variant="body1">
              Ferramenta de Valor Recorrente (FVR) gratuita para marketing de ferramenta educacional.
              Aqui você encontra recursos para estudar aviação, fazer simulados e se preparar para os exames da ANAC
              com acesso ilimitado e recorrente aos nossos materiais de estudo.
            </Typography>
          </CardContent>
        </Card>

        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Simulados FVR
                </Typography>
                <Typography variant="body2">
                  Teste seus conhecimentos com nossa ferramenta de valor recorrente.
                </Typography>
                <Button variant="contained" color="primary" component={Link} to="/simulados" sx={{ mt: 2 }}>
                  Acessar Simulados
                </Button>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Como funciona nossa FVR?
                </Typography>
                <Typography variant="body2">
                  Entenda como nossa ferramenta de marketing educacional funciona!
                </Typography>
                <Button variant="contained" color="primary" component={Link} to="/informacoes" sx={{ mt: 2 }}>
                  Ver Informações
                </Button>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Inscrição ANAC
                </Typography>
                <Typography variant="body2">
                  Informações e link oficial para inscrição na ANAC.
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  href="https://certpessoas.fgv.br/anac/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ mt: 2 }}
                >
                  Site Oficial ANAC
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Home;
